import React from "react";
import { Box, MainText, PressableOpacity } from "app/components/common";
import MultipleAvatarSquare from "app/components/common/MultipleAvatarSquare";
import normalize from "app/utils/normalize";
import { useNavigation } from "@react-navigation/native";
import { IMessageUser } from "@microdoing/shared/services/message/types";
import { isWeb, isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import theme from "app/Theme/Theme";
import ArrowLeft from "app/components/Icons/Arrow/ArrowLeft";

interface Header {
  title: string;
  receivers: IMessageUser[];
  navigateProfile: () => void;
  testId: string;
  clientName: string;
}

const Header = ({
  title = "Mes Amis",
  receivers,
  navigateProfile,
  testID,
  clientName,
  hasBackArrow = true,
}) => {
  const navigation = useNavigation();

  const onPressBack = () => {
    navigation.goBack();
  };

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      borderBottomWidth={1}
      borderBottomColor="neutral.100"
      paddingBottom={isWebDesktop ? "s" : "xs"}
      style={{
        paddingTop: isWebDesktop ? theme.spacing.sm : theme.spacing.xs,
      }}
    >
      {hasBackArrow && (
        <Box justifyContent="center" marginLeft="m">
          <PressableOpacity
            testID={testID}
            onPress={onPressBack}
            hitSlop={{ top: 20, bottom: 20, left: 20, right: 20 }}
          >
            <ArrowLeft color={theme.colors["neutral.900"]} />
          </PressableOpacity>
        </Box>
      )}
      <Box flex={1} marginRight="l" justifyContent="center" alignItems="center">
        <PressableOpacity onPress={navigateProfile}>
          <Box alignItems="center" flexDirection="row">
            <MultipleAvatarSquare users={receivers} size={normalize(24)} />
            <Box
              flexDirection="column"
              marginLeft={isWebDesktop ? "s" : "xs"}
              marginTop={isWebDesktop ? "xxs" : "null"}
            >
              <MainText variant={"l5-medium"}>{title}</MainText>
              {!!clientName && (
                <MainText variant="l2-medium" color="neutral.500">
                  {clientName}
                </MainText>
              )}
            </Box>
          </Box>
        </PressableOpacity>
      </Box>
    </Box>
  );
};

export default Header;
